export default __webpack_public_path__ + "static/media/Minicard_2c.40bd516f.svg";